export * from './ProductDetailsHeaderSmall';
